module.exports = __webpack_public_path__ + "img/single_paragraph.1f89c556.svg";